
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'YouHaveCommentsQuestionsBlock',

  computed: {
    vars: function () {
      return this.$store.state.appState?.vars;
    },

    contactPhone: function () {
      return this.values?.home_phone || this.vars?.['Стационарный телефон'];
    },
    mobilePhone: function () {
      return this.values?.mobile_phone || this.vars?.['Мобильный телефон'];
    },
    emailAddress: function () {
      return this.values?.email || this.vars?.['Почтовый адрес'];
    },
  },

  methods: {
    sendMessage: function () {
      const title = this.values?.title || 'У вас есть замечания или вопросы?';
      const reachGoal = this.values?.yandex_reach_goal || 'у_вас_есть_замечания_или_вопросы';
      const type = this.values?.form_type || 'У вас есть замечания или вопросы?';

      this.$store.commit('pop-up-back-call/open', {
        type: type,
        title: title,
        reachGoal: reachGoal,
      });
    },
  },
});
